<template>
  <div class="modal" :class="{ 'is-active': visible }">
    <div class="modal-background" @click="$emit('close')"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">
          {{ code?.id ? 'Edit Code' : 'New Code' }}
        </p>
        <button
          class="delete"
          aria-label="close"
          @click="$emit('close')"
        ></button>
      </header>

      <section class="modal-card-body">
        <div class="field">
          <label class="label">Label</label>
          <div class="control">
            <input v-model="form.label" class="input" type="text" />
          </div>

          <!-- 🔥 ERROR -->
          <p v-if="errors.label" class="help is-danger">
            {{ errors.label[0] }}
          </p>
        </div>

        <div class="field">
          <label class="label">Description</label>
          <div class="control">
            <textarea v-model="form.description" class="textarea"></textarea>
          </div>
        </div>

        <div class="field">
          <label class="checkbox">
            <input type="checkbox" v-model="form.is_active" />
            Active
          </label>
        </div>
      </section>

      <footer class="modal-card-foot">
        <button class="button is-success" @click="save">Save</button>
        <button class="button" @click="$emit('close')">Cancel</button>
      </footer>
    </div>
  </div>
</template>

<script>
import api from '@/utils/axios';

export default {
  name: 'CodeFormModal',
  props: {
    visible: { type: Boolean, default: false },
    code: { type: Object, default: null },
    conceptId: { type: Number, required: true },
  },
  data() {
    return {
      form: {
        label: '',
        description: '',
        is_active: true,
        concept: null,
      },
      errors: {},
    };
  },
  watch: {
    visible(val) {
      if (val) {
        // Reset form when modal opens
        this.form = {
          label: '',
          description: '',
          is_active: true,
          concept: this.conceptId,
        };

        // If editing → fill form
        if (this.code) {
          this.form = {
            label: this.code.label,
            description: this.code.description,
            is_active: this.code.is_active,
            concept: this.conceptId,
          };
        }
      }
    },

    conceptId(val) {
      this.form.concept = val;
    },
  },

  methods: {
    async save() {
      try {
        this.errors = {}; // reset errors

        if (this.code?.id) {
          await api.put(`/analytics/codes/${this.code.id}/`, this.form);
        } else {
          await api.post('/analytics/codes/', this.form);
        }

        this.$emit('saved');
        this.$emit('close');
      } catch (e) {
        console.error(e);

        if (e.response && e.response.data) {
          this.errors = e.response.data; // 🔥 récupère erreurs backend
        } else {
          alert('Error saving code');
        }
      }
    },
  },
};
</script>
